module.exports = __webpack_public_path__ + "img/404.aec6ab7d.png";